import { render, staticRenderFns } from "./AdminCommissions.vue?vue&type=template&id=0b480db0&scoped=true"
import script from "./AdminCommissions.vue?vue&type=script&lang=js"
export * from "./AdminCommissions.vue?vue&type=script&lang=js"
import style0 from "./AdminCommissions.vue?vue&type=style&index=0&id=0b480db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b480db0",
  null
  
)

export default component.exports